import React from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '../../Buttons/ButtonBase';

const useStyles = makeStyles({
    textField: {
        maxWidth: 600,
        margin: '0 0 20px',
        height: 'auto',
        // '@media screen and (max-width: 400px)': {
        //   maxWidth: 296,
        //   width: 296
        // },
    },
    buttonStyle: {
        minWidth: 208,
    },
    form: {
        display: 'flex',
        flexDirection: 'column'
    }
})

const PublishAnswerForm = ({
    handleBlur,
    handleChange,
    handleSubmit,
    values,
    touched,
    isValid,
    errors
}) => {

    const classes = useStyles()

    return (
        <form className={classes.form}>
            <TextField
                multiline
                fullWidth
                type="text"
                rowsMax={4}
                variant="outlined"
                id="communityAnswer"
                label="Responder pregunta"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.communityAnswer}
                classes={{ root: classes.textField }}
                error={touched.communityAnswer && errors.communityAnswer ? true : false}
                helperText={
                    touched.communityAnswer && errors.communityAnswer ? errors.communityAnswer : ''
                }
            />

            <ButtonBase
                variant='primary'
                onClick={handleSubmit}
                buttonStyle={classes.buttonStyle}
                disabled={!isValid}
            >
                Publicar respuesta
            </ButtonBase>
        </form>
    )
}

export default PublishAnswerForm;
